
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOS";
import TableApp from "@/components/Table/Table3.vue";
import { Money } from "v-money";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import ClockOutline from "vue-material-design-icons/ClockOutline.vue";
import { priceOptions, quantityOptions } from "@/modules/Application";
import ModalServico from "./ModalServico.vue";
import ListaPrecoServicoSelect from "@/modules/Servicos/components/ListaPrecoServicoSelect.vue";

export default {
  name: "app-nfse-form-servicos",
  components: {
    VueSelect,
    TableApp,
    Money,
    Plus,
    Pencil,
    ClockOutline,
    TrashCanIcon,
    ModalServico,
    ListaPrecoServicoSelect,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      priceOptions,
      quantityOptions,
      form: {},
      servicoSelected: null,
      servicosFetched: [],
      selectedLista: null,
      servicos: [],
      quantidade: 0,
      unitario: 0,
      total: 0,
      servicoToEdit: null,
      modalServicoIsOpen: false,
      modalHorimetroIsOpen: false,
      horimetroEditingIndex: null,
      horimetroForm: {
        tipo: "horimetro",
        horimetroInicial: 0,
        horimetroFinal: 0,
        horas: [],
      },
      horimetroTipoOptions: [
        {
          text: "Horímetro",
          value: "horimetro",
        },
        {
          text: "Horímetro manual",
          value: "manual",
        },
      ],
      keyToRender: 0,
      fields: [
        {
          label: "Descrição",
          field: "discriminacao",
          slot: true,
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Qtd",
          field: "quantidade",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Unitario",
          field: "unitario",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Total",
          field: "total",
          slot: true,
          sortable: false,
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  methods: {
    ...mapActions(["setLoading"]),
    openModalServico(servicoData, originalIndex) {
      this.servicoToEdit = {
        ...servicoData,
        originalIndex,
      };
      this.modalServicoIsOpen = true;
    },
    closeModalServico() {
      this.modalServicoIsOpen = false;
    },
    openModalHorimetro(servicoData, originalIndex) {
      this.horimetroEditingIndex = originalIndex;
      this.unitario = Number(servicoData.unitario || servicoData.valor || 0);
      this.loadHorimetroForm(servicoData.horimetro_dados);
      this.modalHorimetroIsOpen = true;
    },
    openCurrentHorimetroModal() {
      this.horimetroEditingIndex = null;
      this.modalHorimetroIsOpen = true;
    },
    handleDeleteServico(serviceToDelete) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o serviço " + serviceToDelete.discriminacao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const aux = this.servicos
              .filter(
                (servico) =>
                  servico.originalIndex !== serviceToDelete.originalIndex
              )
              .map((serviceToDelete, index) => ({
                ...serviceToDelete,
                originalIndex: index,
              }));
            this.servicos = [...aux];
            this.keyToRender++;
          }
        });
    },
    saveEditProduto(newEditServico) {
      const servicoEditado = this.normalizeServicoHorimetro({
        ...newEditServico,
      });

      this.$set(this.servicos, newEditServico.originalIndex, servicoEditado);
      this.keyToRender++;
      this.closeModalServico();
    },
    onSearchServico(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchServicos(loading, search, this);
      }
    },
    searchServicos: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/servicos/filter", {
        discriminacao: search,
        ...(vm.selectedLista && { lista_selecionada: vm.selectedLista }),
      });
      vm.servicosFetched = [...data];
      loading(false);
    }, 350),
    isHorimetroActive(value) {
      return value === true || value === 1 || value === "1";
    },
    setServico() {
      if (_.isEmpty(this.servicoSelected)) {
        this.quantidade = 0;
        this.unitario = 0;
        this.total = 0;
        return;
      }

      this.unitario = Number(
        this.servicoSelected.preco_lista_servico ??
          this.servicoSelected.valor ??
          0
      );
      if (this.isHorimetroActive(this.servicoSelected.horimetro)) {
        this.quantidade = 0;
        this.total = 0;
        this.resetHorimetroForm();
        this.modalHorimetroIsOpen = true;
        return;
      }

      this.quantidade = 1;
      this.total = this.unitario * this.quantidade;
    },
    addServico(servico) {
      if (_.isEmpty(servico)) return;

      if (this.isHorimetroActive(servico.horimetro) && !this.quantidade) {
        this.modalHorimetroIsOpen = true;
        return;
      }

      this.servicos.push({
        ...servico,
        total: this.total,
        unitario: this.unitario,
        quantidade: this.quantidade,
        horimetro_dados: this.isHorimetroActive(servico.horimetro)
          ? this.getHorimetroPayload()
          : null,
        originalIndex: this.servicos.length,
      });

      this.clearFields();
    },
    clearFields() {
      this.quantidade = 0;
      this.unitario = 0;
      this.total = 0;
      this.desconto = 0;
      this.servicoSelected = null;
      this.resetHorimetroForm();
    },
    resetHorimetroForm() {
      this.horimetroForm = this.getEmptyHorimetroForm();
    },
    getEmptyHorimetroForm() {
      return {
        tipo: "horimetro",
        horimetroInicial: 0,
        horimetroFinal: 0,
        horas: [],
      };
    },
    loadHorimetroForm(horimetroDados) {
      const dados = horimetroDados || {};
      const emptyForm = this.getEmptyHorimetroForm();
      const tipo = ["horimetro", "manual"].includes(dados.tipo)
        ? dados.tipo
        : emptyForm.tipo;

      this.horimetroForm = {
        tipo,
        horimetroInicial: dados.horimetroInicial || emptyForm.horimetroInicial,
        horimetroFinal: dados.horimetroFinal || emptyForm.horimetroFinal,
        horas: Array.isArray(dados.horas)
          ? dados.horas.map((hora) => ({
              inicio: hora.inicio || null,
              fim: hora.fim || null,
            }))
          : [],
      };
    },
    cancelHorimetro() {
      this.modalHorimetroIsOpen = false;
      if (this.horimetroEditingIndex !== null) {
        this.horimetroEditingIndex = null;
        this.resetHorimetroForm();
        return;
      }

      this.clearFields();
    },
    addHoraManual() {
      this.horimetroForm.horas.push({
        inicio: null,
        fim: null,
      });
    },
    removeHoraManual(index) {
      this.horimetroForm.horas.splice(index, 1);
    },
    getTimeMinutes(value) {
      if (!value) return null;

      const parts = value.split(":").map((part) => parseInt(part, 10));
      if (parts.length < 2 || parts.some((part) => Number.isNaN(part))) {
        return null;
      }

      const [hours, minutes] = parts;
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return null;
      }

      return hours * 60 + minutes;
    },
    calculatePeriodoHoras(inicio, fim) {
      const inicioMinutes = this.getTimeMinutes(inicio);
      const fimMinutes = this.getTimeMinutes(fim);

      if (inicioMinutes === null || fimMinutes === null) return null;

      let diferenca = fimMinutes - inicioMinutes;
      if (diferenca < 0) {
        diferenca += 24 * 60;
      }

      return diferenca / 60;
    },
    calculateHorimetroHoras() {
      if (this.horimetroForm.tipo === "horimetro") {
        const horimetroInicial = Number(this.horimetroForm.horimetroInicial || 0);
        const horimetroFinal = Number(this.horimetroForm.horimetroFinal || 0);

        if (horimetroFinal <= horimetroInicial) return null;

        return horimetroFinal - horimetroInicial;
      }

      if (this.horimetroForm.horas.length === 0) return null;

      return this.horimetroForm.horas.reduce((total, hora) => {
        const periodoHoras = this.calculatePeriodoHoras(
          hora.inicio,
          hora.fim
        );

        if (periodoHoras === null) return null;
        if (total === null) return null;

        return total + periodoHoras;
      }, 0);
    },
    calculateHorimetroHorasFromDados(horimetroDados) {
      const currentForm = this.horimetroForm;

      this.loadHorimetroForm(horimetroDados);
      const horas = this.calculateHorimetroHoras();
      this.horimetroForm = currentForm;

      return horas;
    },
    normalizeServicoHorimetro(servico) {
      if (
        !this.isHorimetroActive(servico.horimetro) ||
        !servico.horimetro_dados
      ) {
        return servico;
      }

      const horas = this.calculateHorimetroHorasFromDados(
        servico.horimetro_dados
      );

      if (!horas || horas <= 0) {
        return servico;
      }

      const quantidade = Number(horas.toFixed(3));
      const unitario = Number(servico.unitario || servico.valor || 0);

      return {
        ...servico,
        quantidade,
        unitario,
        total: unitario * quantidade,
      };
    },
    getHorimetroPayload() {
      return {
        tipo: this.horimetroForm.tipo,
        horimetroInicial: this.horimetroForm.horimetroInicial,
        horimetroFinal: this.horimetroForm.horimetroFinal,
        horas: this.horimetroForm.horas.map((hora) => ({ ...hora })),
      };
    },
    saveHorimetro() {
      const horas = this.calculateHorimetroHoras();

      if (!horas || horas <= 0) {
        const mensagem =
          this.horimetroForm.tipo === "horimetro"
            ? "Preencha uma leitura válida para o horímetro!"
            : "Preencha um período válido para o horímetro!";
        this.$toast.error(mensagem);
        return;
      }

      this.quantidade = Number(horas.toFixed(3));
      this.total = this.unitario * this.quantidade;
      this.modalHorimetroIsOpen = false;

      if (this.horimetroEditingIndex !== null) {
        const servico = this.servicos[this.horimetroEditingIndex];

        this.$set(this.servicos, this.horimetroEditingIndex, {
          ...servico,
          quantidade: this.quantidade,
          unitario: this.unitario,
          total: this.total,
          horimetro_dados: this.getHorimetroPayload(),
        });
        this.keyToRender++;
        this.horimetroEditingIndex = null;
        this.clearFields();
      }
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { servicos } = this.$route.params.osData;
      this.servicos = servicos ?? [];
    } else if (Array.isArray(this.store.formServicos)) {
      this.servicos = [...this.store.formServicos];
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return this.store.currentTab === 4;
    },
  },
  watch: {
    "store.formServicos"(newValue) {
      if (Array.isArray(newValue) && !_.isEqual(newValue, this.servicos)) {
        this.servicos = [...newValue];
      }
    },
    servicos: {
      handler(newValue) {
        this.store.formServicos = newValue;
      },
      deep: true,
    },
    quantidade(value) {
      this.total = this.unitario * parseFloat(value);
    },
    unitario(value) {
      this.total = parseFloat(value) * this.quantidade;
    },
    form(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      this.store.formCabecalho = newValue;
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 5 && oldValue < newValue) {
        console.log();
      }
    },
  },
};
